const descendantOptions = (node, prefix) => {
  if (!Object.keys(node.children ?? {}).length) {
    return [{ value: node.id, text: prefix }]
  }

  return Object.entries(node.children ?? {}).flatMap(([id, child]) => {
    const text = `${prefix} / ${child.name}`

    return descendantOptions({ ...child, id }, text)
  })
}

export const selectableCategoryOptionGroups = (platform) => {
  if (!platform?.children) return {}

  return Object.entries(platform.children).reduce((groups, [id, child]) => {
    groups[child.name] = descendantOptions({ ...child, id }, child.name)

    return groups
  }, {})
}

export const selectableCategoryOptions = (platform) => {
  return Object.values(selectableCategoryOptionGroups(platform)).flat()
}
